import React from "react";
import { useState } from "react";
import userIcon from "../../../assets/user_icon.png";
import artistIcon from "../../../assets/artist_icon.png";
import { AuthNavbar } from "../../../components/auth/AuthNavbar";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../../components/button/CustomButton";
import { toast } from "react-hot-toast";

export const UserType = () => {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();

  const handleNavigation = () => {
    if (selected == null) {
      toast.error("Please choose any user type");
      return false;
    }
    navigate(`/signup/${selected}`);
  };

  return (
    <div className="w-full min-h-screen sm:h-screen bg-[#F7F7F7] flex items-center justify-center overflow-auto">
      <AuthNavbar />
      <div className="w-full max-w-[653px] p-5 mt-20 mb-10">
        <p className="text-center mb-6 font-bold text-2xl sm:text-[32px] text-[#3749A6] font-grotesk">
          Select User Type
        </p>
        {/* Centered card */}
        <div className="flex flex-col justify-center items-center min-h-[360px] py-4 bg-white rounded-[20px] shadow-md w-full gap-10 px-4">
          <div className="w-full flex justify-center items-center flex-wrap gap-[10px]">
            {/* User Card */}
            <label
              className={`cursor-pointer flex flex-col items-center justify-center rounded-[10px] border-2 w-full h-[160px] xs:w-[195px] xs:h-[156px] bg-white transition
                             ${
                               selected === "user"
                                 ? "border-primary bg-[#F7F7F7]"
                                 : "border-border_color bg-white"
                             }`}
            >
              <input
                type="radio"
                name="userType"
                value="user"
                checked={selected === "user"}
                onChange={() => setSelected("user")}
                className="hidden"
              />
              <div className="w-16 h-16 flex items-center justify-center overflow-hidden mb-2">
                <img
                  src={userIcon}
                  alt="User"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <span className="font-medium text-black text-xl font-grotesk">
                As a User
              </span>
            </label>
            {/* Artist Card */}
            <label
              className={`cursor-pointer flex flex-col items-center justify-center rounded-[10px] border-2 w-full h-[160px] xs:w-[195px] xs:h-[156px] bg-white transition
                            ${
                              selected === "artist"
                                ? "border-primary bg-[#F7F7F7]"
                                : "border-border_color bg-white"
                            }`}
            >
              <input
                type="radio"
                name="userType"
                value="artist"
                checked={selected === "artist"}
                onChange={() => setSelected("artist")}
                className="hidden"
              />
              <div className="w-16 h-16 flex items-center justify-center overflow-hidden mb-2">
                <img
                  src={artistIcon}
                  alt="Artist"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <span className="font-medium text-black text-xl font-grotesk">
                As an Artist
              </span>
            </label>
          </div>
          <div className="w-full max-w-[407px]">
            <CustomButton text="Next" onClick={handleNavigation} />
          </div>
        </div>
      </div>
    </div>
  );
};
